import { render, staticRenderFns } from "./SelfInstallDetails.vue?vue&type=template&id=84479b14&"
import script from "./SelfInstallDetails.vue?vue&type=script&lang=js&"
export * from "./SelfInstallDetails.vue?vue&type=script&lang=js&"
import style0 from "./SelfInstallDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports